import { useState, useRef, useEffect } from 'react';

const API_URL = 'https://beta.api.dynamicwerx.com/AIChat/SendPrompt?prompt=';
const BEARER_TOKEN = sessionStorage.getItem('UserAuthToken');

const BOT_ICON =
  'data:image/png;base64,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';

function renderHtmlSafely(html) {
  return html
    .replace(/color\s*:\s*White/gi, '')
    .replace(/color\s*:\s*white/gi, '');
}

function Avatar({ role }) {
  if (role === 'assistant') {
    return (
      <img
        src={BOT_ICON}
        alt='AI'
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          flexShrink: 0,
          objectFit: 'cover'
        }}
      />
    );
  }
  const map = {
    user: { label: 'You', bg: '#f1efe8', color: '#5f5e5a' },
    tool: { label: 'FN', bg: '#eaf3de', color: '#3b6d11' }
  };
  const s = map[role] || map.user;
  return (
    <div
      style={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        background: s.bg,
        color: s.color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 10,
        fontWeight: 600,
        flexShrink: 0
      }}
    >
      {s.label}
    </div>
  );
}

function MessageBubble({ role, text, isHtml, elapsed }) {
  const isUser = role === 'user';
  const isTool = role === 'tool';
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isUser ? 'flex-end' : 'flex-start',
        maxWidth: '78%'
      }}
    >
      <div
        style={{
          fontSize: 10,
          color: '#aaa',
          marginBottom: 3,
          display: 'flex',
          gap: 6
        }}
      >
        <span>{role === 'tool' ? 'tool result' : role}</span>
        {elapsed != null && <span style={{ color: '#bbb' }}>{elapsed}s</span>}
      </div>
      <div
        style={{
          padding: '8px 12px',
          borderRadius: isUser ? '12px 4px 12px 12px' : '4px 12px 12px 12px',
          fontSize: 13,
          lineHeight: 1.55,
          border: '0.5px solid #e0ddd5',
          background: isUser ? '#e6f1fb' : isTool ? '#eaf3de' : '#f7f6f2',
          color: '#1a1a1a',
          fontFamily: isTool ? 'monospace' : 'inherit',
          wordBreak: 'break-word'
        }}
      >
        {isHtml ? (
          <div dangerouslySetInnerHTML={{ __html: renderHtmlSafely(text) }} />
        ) : (
          text.split('\n').map((line, i) => (
            <span key={i}>
              {line}
              <br />
            </span>
          ))
        )}
      </div>
    </div>
  );
}

function TimerBadge({ seconds }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 20,
        background: '#fff3cd',
        border: '0.5px solid #ffc107',
        fontSize: 12,
        color: '#856404',
        fontWeight: 500,
        alignSelf: 'flex-start'
      }}
    >
      <svg
        width='12'
        height='12'
        viewBox='0 0 24 24'
        fill='none'
        stroke='#856404'
        strokeWidth='2.5'
        strokeLinecap='round'
      >
        <circle cx='12' cy='12' r='10' />
        <polyline points='12 6 12 12 16 14' />
      </svg>
      Waiting... {seconds}s
    </div>
  );
}

function TypingIndicator() {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
      <Avatar role='assistant' />
      <div
        style={{
          padding: '10px 14px',
          background: '#f7f6f2',
          borderRadius: '4px 12px 12px 12px',
          border: '0.5px solid #e0ddd5',
          display: 'flex',
          gap: 5,
          alignItems: 'center'
        }}
      >
        {[0, 1, 2].map(i => (
          <div
            key={i}
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: '#bbb',
              animation: 'tmsBlink 1.2s infinite',
              animationDelay: `${i * 0.2}s`
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default function TMSChatWidget() {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      text: "Hi! I'm your TMS Assistant. Ask me anything about your shipments, carriers, or logistics data.",
      isHtml: false
    }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [history, setHistory] = useState([]);
  const [unread, setUnread] = useState(0);
  const [timer, setTimer] = useState(0);
  const timerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);

  const WIDGET_WIDTH = expanded ? 680 : 370;
  const WIDGET_HEIGHT = expanded ? 620 : 540;

  useEffect(() => {
    if (open) {
      setUnread(0);
      setTimeout(
        () => messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' }),
        100
      );
    }
  }, [open]);

  useEffect(() => {
    if (open) messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  useEffect(() => {
    if (open && textareaRef.current) textareaRef.current.focus();
  }, [open]);

  useEffect(() => {
    if (loading) {
      setTimer(0);
      timerRef.current = setInterval(() => setTimer(t => t + 1), 1000);
    } else {
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [loading]);

  function processResponse(data, elapsed) {
    const newMsgs = [];
    if (!data?.data) return newMsgs;
    data.data.forEach(entry => {
      const role = (entry.role?.label || '').toLowerCase();
      if (!entry.items) return;
      entry.items.forEach(item => {
        if (item.$type === 'TextContent' && item.text) {
          if (role === 'assistant')
            newMsgs.push({
              role: 'assistant',
              text: item.text,
              isHtml: false,
              elapsed
            });
          else if (role === 'tool') {
            const isHtml = /<[a-z][\s\S]*>/i.test(item.text);
            newMsgs.push({ role: 'tool', text: item.text, isHtml, elapsed });
          }
        } else if (item.$type === 'FunctionCallContent') {
          newMsgs.push({
            role: 'assistant',
            text: `Calling: ${item.pluginName} → ${item.functionName}`,
            isHtml: false
          });
        } else if (item.$type === 'FunctionResultContent') {
          const res = item.result || '';
          const isHtml = /<[a-z][\s\S]*>/i.test(res);
          newMsgs.push({ role: 'tool', text: res, isHtml, elapsed });
        }
      });
    });
    return newMsgs;
  }

  async function sendMessage() {
    const text = input.trim();
    if (!text || loading) return;

    setMessages(prev => [...prev, { role: 'user', text, isHtml: false }]);
    setInput('');
    setError('');
    setLoading(true);
    if (textareaRef.current) textareaRef.current.style.height = 'auto';

    const updatedHistory = [...history, { role: 'user', content: text }];
    const startTime = Date.now();

    try {
      const res = await fetch(`${API_URL}${encodeURIComponent(text)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${BEARER_TOKEN}`
        }
      });

      const elapsed = ((Date.now() - startTime) / 1000).toFixed(1);

      if (!res.ok) {
        const errText = await res.text();
        setError(`API error ${res.status}: ${errText.slice(0, 150)}`);
        return;
      }

      const data = await res.json();
      const newMsgs = processResponse(data, elapsed);
      setMessages(prev => [...prev, ...newMsgs]);

      if (!open)
        setUnread(u => u + newMsgs.filter(m => m.role === 'assistant').length);

      const lastText = newMsgs.filter(m => m.role === 'assistant').pop()?.text;
      setHistory(
        lastText
          ? [...updatedHistory, { role: 'assistant', content: lastText }]
          : updatedHistory
      );
    } catch (err) {
      setError(`Network error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  }

  return (
    <>
      <style>{`
        @keyframes tmsBlink { 0%,80%,100%{opacity:.2} 40%{opacity:1} }
        @keyframes tmsSlideUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        .tms-widget-window { animation: tmsSlideUp 0.22s ease; transition: width 0.25s ease, height 0.25s ease; }
        .tms-textarea:focus { outline: none; border-color: #378add !important; box-shadow: 0 0 0 3px rgba(55,138,221,0.12); }
        .tms-send-btn:hover:not(:disabled) { background: #0c447c !important; }
        .tms-fab:hover { transform: scale(1.08); box-shadow: 0 6px 24px rgba(24,95,165,0.35) !important; }
        .tms-messages::-webkit-scrollbar { width: 4px; }
        .tms-messages::-webkit-scrollbar-thumb { background: #ddd; border-radius: 4px; }
        .tms-icon-btn { border-radius: 8px; transition: background 0.15s; }
        .tms-icon-btn:hover { background: rgba(255,255,255,0.18) !important; }
      `}</style>

      {open && (
        <div
          className='tms-widget-window'
          style={{
            position: 'fixed',
            bottom: 88,
            right: 24,
            zIndex: 9999,
            width: WIDGET_WIDTH,
            height: WIDGET_HEIGHT,
            background: '#fff',
            borderRadius: 16,
            boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
            display: 'flex',
            flexDirection: 'column',
            border: '0.5px solid #e0ddd5',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            overflow: 'hidden'
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: '12px 16px',
              background: '#185fa5',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              flexShrink: 0
            }}
          >
            <img
              src={BOT_ICON}
              alt='TMS AI'
              style={{
                width: 36,
                height: 36,
                borderRadius: '50%',
                objectFit: 'cover',
                border: '2px solid rgba(255,255,255,0.3)'
              }}
            />
            <div style={{ flex: 1 }}>
              <div style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>
                TMS Assistant
              </div>
              <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 11 }}>
                {loading ? `Typing... (${timer}s)` : 'Online'}
              </div>
            </div>

            {/* Expand / Collapse button */}
            <button
              className='tms-icon-btn'
              onClick={() => setExpanded(e => !e)}
              title={expanded ? 'Collapse' : 'Expand'}
              style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.18)',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                flexShrink: 0
              }}
            >
              {expanded ? (
                <svg
                  width='15'
                  height='15'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <polyline points='4 14 10 14 10 20' />
                  <polyline points='20 10 14 10 14 4' />
                  <line x1='10' y1='14' x2='3' y2='21' />
                  <line x1='21' y1='3' x2='14' y2='10' />
                </svg>
              ) : (
                <svg
                  width='15'
                  height='15'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <polyline points='15 3 21 3 21 9' />
                  <polyline points='9 21 3 21 3 15' />
                  <line x1='21' y1='3' x2='14' y2='10' />
                  <line x1='3' y1='21' x2='10' y2='14' />
                </svg>
              )}
            </button>

            {/* Close button — same circle style, matches FAB open state */}
            <button
              className='tms-icon-btn'
              onClick={() => setOpen(false)}
              title='Close chat'
              style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.18)',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                flexShrink: 0
              }}
            >
              <svg
                width='15'
                height='15'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2.5'
                strokeLinecap='round'
              >
                <line x1='18' y1='6' x2='6' y2='18' />
                <line x1='6' y1='6' x2='18' y2='18' />
              </svg>
            </button>
          </div>

          {/* Messages */}
          <div
            className='tms-messages'
            style={{
              flex: 1,
              overflowY: 'auto',
              padding: '14px',
              display: 'flex',
              flexDirection: 'column',
              gap: 12
            }}
          >
            {messages.map((msg, i) => (
              <div
                key={i}
                style={{
                  display: 'flex',
                  flexDirection: msg.role === 'user' ? 'row-reverse' : 'row',
                  gap: 8,
                  alignItems: 'flex-start'
                }}
              >
                <Avatar role={msg.role} />
                <MessageBubble
                  role={msg.role}
                  text={msg.text}
                  isHtml={msg.isHtml}
                  elapsed={msg.elapsed}
                />
              </div>
            ))}
            {loading && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <TypingIndicator />
                <TimerBadge seconds={timer} />
              </div>
            )}
            {error && (
              <div
                style={{
                  fontSize: 12,
                  color: '#a32d2d',
                  background: '#fcebeb',
                  border: '0.5px solid #f09595',
                  borderRadius: 8,
                  padding: '6px 10px'
                }}
              >
                {error}
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Input Bar */}
          <div
            style={{
              padding: '10px 12px',
              borderTop: '0.5px solid #e0ddd5',
              display: 'flex',
              gap: 8,
              alignItems: 'flex-end',
              background: '#fafafa'
            }}
          >
            <textarea
              ref={textareaRef}
              className='tms-textarea'
              rows={1}
              value={input}
              onChange={e => {
                setInput(e.target.value);
                e.target.style.height = 'auto';
                e.target.style.height =
                  Math.min(e.target.scrollHeight, 100) + 'px';
              }}
              onKeyDown={handleKeyDown}
              placeholder='Ask something...'
              style={{
                flex: 1,
                padding: '8px 12px',
                fontSize: 13,
                border: '0.5px solid #ccc',
                borderRadius: 10,
                fontFamily: 'inherit',
                lineHeight: 1.5,
                maxHeight: 100,
                overflow: 'auto',
                resize: 'none',
                background: '#fff',
                color: '#1a1a1a',
                transition: 'border-color 0.15s, box-shadow 0.15s'
              }}
            />
            <button
              className='tms-send-btn'
              onClick={sendMessage}
              disabled={loading || !input.trim()}
              style={{
                padding: '8px 14px',
                borderRadius: 10,
                fontSize: 13,
                border: 'none',
                background: loading || !input.trim() ? '#c8d8ec' : '#185fa5',
                color: '#fff',
                cursor: loading || !input.trim() ? 'default' : 'pointer',
                fontWeight: 500,
                whiteSpace: 'nowrap',
                transition: 'background 0.15s'
              }}
            >
              {loading ? `${timer}s...` : 'Send'}
            </button>
          </div>
        </div>
      )}

      {/* FAB — bot icon always visible; blue overlay with X fades in when open */}
      <button
        className='tms-fab'
        onClick={() => setOpen(o => !o)}
        title={open ? 'Close chat' : 'Open TMS Assistant'}
        style={{
          position: 'fixed',
          bottom: 4,
          right: 1,
          zIndex: 9999,
          width: 60,
          height: 60,
          borderRadius: '50%',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          overflow: 'hidden',
          boxShadow: '0 4px 20px rgba(24,95,165,0.45)',
          transition: 'transform 0.15s, box-shadow 0.15s'
        }}
      >
        {/* Bot image always underneath */}
        <img
          src={BOT_ICON}
          alt='TMS Chat'
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            objectFit: 'cover'
          }}
        />
        {/* Blue overlay + X icon fades in when open */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            background: '#185fa5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: open ? 1 : 0,
            transition: 'opacity 0.2s ease'
          }}
        >
          <svg
            width='22'
            height='22'
            viewBox='0 0 24 24'
            fill='none'
            stroke='white'
            strokeWidth='2.5'
            strokeLinecap='round'
          >
            <line x1='18' y1='6' x2='6' y2='18' />
            <line x1='6' y1='6' x2='18' y2='18' />
          </svg>
        </div>
        {/* Unread badge */}
        {!open && unread > 0 && (
          <div
            style={{
              position: 'absolute',
              top: 3,
              right: 3,
              width: 18,
              height: 18,
              borderRadius: '50%',
              background: '#e24b4a',
              color: '#fff',
              fontSize: 10,
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px solid #fff',
              zIndex: 1
            }}
          >
            {unread}
          </div>
        )}
      </button>
    </>
  );
}
